import React from "react";
import { Box } from "@mui/material";
import styled from "styled-components";
import { useThemeMode, darkColors, lightColors } from "@/colors";
import { HeroCTA } from "./HeroCTA";
import { Grainient } from "./animations";

const HeroContainer = styled(Box)`
  position: relative;
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding-top: 64px;
  overflow: hidden;
`;

const HeroBackground = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
`;

const HeroOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${props => props.theme.palette.background.default};
  opacity: 0.2;
  z-index: 1;
`;

const HeroAnimation = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
`;

const HeroContent = styled.div`
  position: relative;
  z-index: 3;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Hero: React.FC = () => {
  const { mode } = useThemeMode();
  const isDark = mode === "dark";
  const brandColors = isDark ? darkColors.background.brand : lightColors.background.brand;

  return (
    <HeroContainer>
      <HeroBackground
        src={isDark ? "/hero-dark.png" : "/hero-light.png"}
        alt={isDark ? "San Francisco skyline - dark theme" : "San Francisco skyline - light theme"}
      />
      <HeroOverlay />
      <HeroAnimation>
        <Grainient
          color1={brandColors.dark}
          color2={brandColors.lightest}
          color3={brandColors.light}
          timeSpeed={2}
        />
      </HeroAnimation>
      <HeroContent>
        <HeroCTA />
      </HeroContent>

    </HeroContainer>
  );
};
